export const time = {
    "alert_time_out": "Time up!",
    "hours": "hour",
    "minute": "minutes",
    "second": "seconds",
    "time_worked": "Duration",
    "time": "Duration",
    "times": "attempts",
};
